import instance from "services/api";
import { isForbiddenError } from "utils/requestHelpers";

// Остальные ошибки по-прежнему глушим, а 403 пробрасываем,
// чтобы страница показала сообщение об отсутствии доступа.
const rethrowForbidden = (err) => {
  if (isForbiddenError(err)) throw err;
};

export const getRoutes = (params) => {
  return instance()
    .get(`/infobus/getRoutes?${params}`)
    .then((res) => res?.data || [])
    .catch(rethrowForbidden);
};

export const getPaymentTypes = () => {
  return instance()
    .get(`/infobus/getPaymentTypes`)
    .then((res) => res?.data || [])
    .catch(rethrowForbidden);
};

export const getYears = () => {
  return instance()
    .get(`/infobus/getYears`)
    .then((res) => res?.data || [])
    .catch(rethrowForbidden);
};

export const getTransactionByDay = (params) => {
  return instance()
    .get(`/infobus/getTransactionByDay?${params}`)
    .then((res) => res?.data || [])
    .catch(rethrowForbidden);
};

export const getTransactionByType = (params) => {
  return instance()
    .get(`/infobus/getTransactionByType?${params}`)
    .then((res) => res?.data || [])
    .catch(rethrowForbidden);
};

export const getTransactionByRoute = (params) => {
  return instance()
    .get(`/infobus/getTransactionByRoute?${params}`)
    .then((res) => res?.data || [])
    .catch(rethrowForbidden);
};

export const getTransactionByMonth = (params) => {
  return instance()
    .get(`/infobus/getTransactionByMonth?${params}`)
    .then((res) => res?.data || [])
    .catch(rethrowForbidden);
};

export const getSentimentResourceStats = (params) => {
  return instance()
    .get(`/alem/sentimentResourceStats?${params}`)
    .then((res) => res?.data || [])
    .catch(rethrowForbidden);
};
